import { useNavigate } from "react-router-dom";
import { Box, IconButton, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs } from "@mui/material";
import React, { useState } from "react";
import MainContainer from "../../../layout/MainContainer";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const ViewLanguageLibrary = () => {
    const navigate = useNavigate();
    const [valueTabs, setValueTabs] = useState(0);
    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };

    // --- Tasks ---
    const columns = [
        { id: 'task', label: 'Task' },
        { id: 'action', label: 'Action' },
    ];
    const [rows] = useState([
        { id: 1, task: "Wake me at 6 AM" },
        { id: 2, task: "Remind me to drink water" },
        { id: 3, task: "Notify me when it’s 5 PM" },
    ]);

    // --- Meals ---
    const columnsMeals = [
        { id: 'meal', label: 'Meal' },
        { id: 'action', label: 'Action' },
    ];
    const [rowsMeals] = useState([
        { id: 1, meal: "Breakfast at 8 AM" },
        { id: 2, meal: "Lunch at 1 PM" },
        { id: 3, meal: "Dinner at 7 PM" },
    ]);

    // --- Notes ---
    const columnsNotes = [
        { id: 'note', label: 'Note' },
        { id: 'action', label: 'Action' },
    ];
    const [rowsNotes] = useState([
        { id: 1, note: "Call the doctor tomorrow" },
        { id: 2, note: "Buy groceries on Saturday" },
        { id: 3, note: "Meeting with team at 3 PM" },
    ]);

    return (
        <>
            <div className="main_title">
                <h1>Language Library View</h1>
                <p>
                    <span onClick={() => navigate("/dashboard")}>Dashboard</span>
                    {" "} - <span onClick={() => navigate("/translation-messaging")}>Language Library</span>
                    {" "} - View
                </p>
            </div>

            <div className="cards view_page">
                <div className="gap_p">
                    <div className="vew_img w_100">
                        <h6>Language</h6>
                        <p>English</p>
                    </div>
                </div>
            </div>

            <div className="table_header">
                <div className="left_s">
                    <Box className="custom_tabs1" sx={{ width: "100%" }}>
                        <Tabs
                            value={valueTabs}
                            onChange={handleChangeTabs}
                            aria-label="basic tabs example"
                            className="custom_tabs_links"
                        >
                            <Tab label="Tasks" {...a11yProps(0)} />
                            <Tab label="Meals" {...a11yProps(1)} />
                            <Tab label="Notes" {...a11yProps(2)} />
                        </Tabs>
                    </Box>
                </div>
            </div>

            {/* Tasks Tab */}
            <CustomTabPanel value={valueTabs} index={0}>
                <div className="cards">
                    <TableContainer className="table_container">
                        <Table>
                            <TableHead>
                                <TableRow hover>
                                    {columns.map((column) => (
                                        <TableCell key={column.id}>{column.label}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.map((row) => (
                                    <TableRow hover key={row.id}>
                                        <TableCell>{row.task}</TableCell>
                                        <TableCell>
                                            <div className="table_actions v2">
                                                <Box>
                                                    <IconButton onClick={() => console.log("Delete task", row.id)}>
                                                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                                                    </IconButton>
                                                </Box>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </CustomTabPanel>

            {/* Meals Tab */}
            <CustomTabPanel value={valueTabs} index={1}>
                <div className="cards">
                    <TableContainer className="table_container">
                        <Table>
                            <TableHead>
                                <TableRow hover>
                                    {columnsMeals.map((column) => (
                                        <TableCell key={column.id}>{column.label}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rowsMeals.map((row) => (
                                    <TableRow hover key={row.id}>
                                        <TableCell>{row.meal}</TableCell>
                                        <TableCell>
                                            <div className="table_actions v2">
                                                <Box>
                                                    <IconButton onClick={() => console.log("Delete meal", row.id)}>
                                                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                                                    </IconButton>
                                                </Box>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </CustomTabPanel>

            {/* Notes Tab */}
            <CustomTabPanel value={valueTabs} index={2}>
                <div className="cards">
                    <TableContainer className="table_container">
                        <Table>
                            <TableHead>
                                <TableRow hover>
                                    {columnsNotes.map((column) => (
                                        <TableCell key={column.id}>{column.label}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rowsNotes.map((row) => (
                                    <TableRow hover key={row.id}>
                                        <TableCell>{row.note}</TableCell>
                                        <TableCell>
                                            <div className="table_actions v2">
                                                <Box>
                                                    <IconButton onClick={() => console.log("Delete note", row.id)}>
                                                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                                                    </IconButton>
                                                </Box>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </CustomTabPanel>
        </>
    );
};

export default ViewLanguageLibrary;
